import {useState} from 'react';
import moment from "moment-timezone";
import {ThucPhamBaoCao} from "@/services/ThucPham/BaoCao";
import {getBaoCao} from "@/services/ThucPham/BaoCao/baocaothucpham";
import {str2bytes} from "@/utils/utils";
import {message} from "antd";
const xuatBaoCaoInit: ThucPhamBaoCao.XuatBaoCao = {
  startDate: null,
  endDate: null,
  types: [],
  nhomLop: "all",
  danhSachThucPham: [],
  donViId: null
}

export enum BaoCaoThucPham {
  SO_3_BUOC_TONGHOP_BUOC1_1 = "so3BuocTongHop.buoc1_1",
  SO_3_BUOC_TONGHOP_BUOC1_2 = "so3BuocTongHop.buoc1_2",
  SO_3_BUOC_TONGHOP_BUOC2 = "so3BuocTongHop.buoc2",
  SO_3_BUOC_TONGHOP_BUOC3 = "so3BuocTongHop.buoc3",
  SO_3_BUOC_TONGHOP_MAU2_BUOC1_1 = "so3BuocTongHopMau2.buoc1_1",
  SO_3_BUOC_TONGHOP_MAU2_BUOC1_2 = "so3BuocTongHopMau2.buoc1_2",
  SO_3_BUOC_TONGHOP_MAU2_BUOC2 = "so3BuocTongHopMau2.buoc2",
  SO_3_BUOC_TONGHOP_MAU2_BUOC3 = "so3BuocTongHopMau2.buoc3",
  SO_TINH_KHAU_PHAN_AN = "soTinhKhauPhanAn",
  SO_TINH_KHAU_PHAN_AN_MAU_2 = "soTinhKhauPhanAnMau2",
  SO_GIAO_NHAN_THUC_PHAM_MAU_2 = "soGiaoNhanThucPhamMau2",
  SO_KHO_PHIEU_XUAT_KHO = "soKho.phieuXuatKho",
  SO_KHO_PHIEU_XUAT_KHO_HANG_CHO = "soKho.phieuXuatKhoHangCho",
  SO_KHO_PHIEU_NHAP_KHO = "soKho.phieuNhapKho",
  SO_KHO_PHIEU_NHAP_KHO_MAU_2 = "soKho.phieuNhapKhoMau2",
  SO_KHO_THEO_DOI_XUAT_NHAP_KHO = "soKho.theoDoiXuatNhapKho",
  SO_KHO_TONG_HOP = "soKho.tonghop",
  SO_KHO_TONG_HOP_GOP = "soKho.tonghopgop",
  SO_QUY_TIEN_MAT= "soTaiChinh.soQuyTienMat",
  SO_BAO_AN_TONG_HOP = "soBaoAnTongHop",
  SO_BAO_AN_TONG_HOP_MAU_2 = "soBaoAnTongHopMau2",
  SO_TINH_TIEN_AN_TRONG_NGAY = "soTinhTienAnTrongNgay",
  SO_TAI_CHINH_CONG_KHAI = "soTaiChinhCongKhai",
  SO_TAI_CHINH_CONG_KHAI_MAU_2 = "soTaiChinhCongKhaiMau2",
  SO_TAI_CHINH_CONG_KHAI_GOP = "soTaiChinhCongKhaiGop",
  SO_GIAO_NHAN_THUC_PHAM = "soGiaoNhanThucPham",
  PHIEU_THANH_TOAN = "phieuThanhToan",
  SO_CONG_NO = "soCongNo",
  HOA_DON_BAN_HANG = "hoaDonBanHang",
  HOA_DON_HANG_KHO = "hoaDonHangKho",
  HOA_DON_HANG_CHO = "hoaDonHangCho",
  THUC_DON_TUAN = "thucdonTuan",
  NHAN_LUU_MAU = "nhanLuuMau",
  BANG_KE_MUA_HANG = "bangKeMuaHang",
  BANG_KE_THUC_PHAM = "bangKeThucPham",
  MAU_THEO_DOI_MUA_LTTP = "mauTheoDoiMuaLTTP",
  KHAU_PHAN_DINH_DUONG_KHOI = "khauPhanDinhDuongKhoi",
}

export enum LichSuKho {
  NHAP_KHO = "Nhập kho",
  XUAT_KHO = "Xuất kho",
  REPORT_KHO_HANG_NGAY = "Report hàng ngày",
}

export enum LoaiNguyenLieu {
  NHIEN_LIEU = "Nhiên liệu",
  THUC_PHAM = "Thực phẩm",
}

export enum NhomLoaiThucPham {
  NANG_LUONG = "Nhóm 15. Năng lượng"
}

export default () => {
  const [title, setTitle] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [xuatBaoCao, setXuatBaoCao] = useState<ThucPhamBaoCao.XuatBaoCao>(xuatBaoCaoInit);

  const setStartDate = (date: null | moment.Moment) => {
    let endDate = xuatBaoCao.endDate;
    if (moment.isMoment(date) && (!moment.isMoment(endDate) || (moment.isMoment(endDate) && date.isAfter(endDate)))){
      endDate = moment(date);
    }
    setXuatBaoCao(Object.assign({}, xuatBaoCao,{
      startDate: date,
      endDate: endDate,
    }))
  }

  const setDonViId = (donViId: null | string) => {
    setXuatBaoCao(Object.assign({}, xuatBaoCao,{
      donViId: donViId
    }))
  }

  const setDanhSachThucPham = (danhSachThucPham?: string[])=>{
    let selectedThucPham = danhSachThucPham;
    if (!Array.isArray(selectedThucPham)) {
      selectedThucPham = [];
    }
    setXuatBaoCao(Object.assign({},xuatBaoCao,{
      danhSachThucPham: selectedThucPham
    }))
  }

  const setEndDate = (date: null | moment.Moment) => {
    let startDate = xuatBaoCao.startDate;
    if (moment.isMoment(date) && (!moment.isMoment(startDate) || (moment.isMoment(startDate) && date.isBefore(startDate)))){
      startDate = moment(date);
    }
    setXuatBaoCao(Object.assign({}, xuatBaoCao,{
      endDate: date,
      startDate: startDate,
    }))
  }

  const setNhomLop = (value: string) => {
    setXuatBaoCao(Object.assign({}, xuatBaoCao,{
      nhomLop: value
    }))
  }

  const setExportTypes = (type?: any) => {
    let types: any = type;
    if (type === undefined){
      types = [];
    }
    else if (!Array.isArray(type)){
      types = [type.toString()];
    }
    setXuatBaoCao(Object.assign({}, xuatBaoCao,{
      types: types,
      danhSachThucPham: []
    }))
  }

  const exportBaoCao = ()=>{
    setLoading(true);
    return getBaoCao(xuatBaoCao).then((response)=>{
      const data = response.data.data;
      const content = data.content;
      const isZip = !!data.isZip;
      const blob = new Blob([str2bytes(content)],{type: isZip?"application/zip":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      const href = URL.createObjectURL(blob);

      // create "a" HTLM element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', data.name??(`export_${moment().format("YYYY_MM_DD_HH_mm_ss")}.${isZip?"zip":"xlsx"}`)); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      setLoading(false);
    }).catch((error)=>{
      setLoading(false);
      throw error;
    })
  }

  return {
    title,
    xuatBaoCao,
    loading,
    setXuatBaoCao,
    setDanhSachThucPham,
    setTitle,
    setExportTypes,
    setNhomLop,
    setStartDate,
    setDonViId,
    setEndDate,
    exportBaoCao
  };
}
